/**
 * scroll-to.js
 * Scroll to target element.
 *
 */

/**
 * Declare constants
 */
const attributeBase = 'data-rs-scroll-to';

export class ScrollTo {
  constructor(element) {
    this.element = element;
    this.target = document.querySelector(element.getAttribute(this.attributes.target));

    this.triggerClass = element.getAttribute(this.attributes.triggerClass);

    if (!this.target) {
      console.error('ScrollTo: Target element not found');
      return;
    }

    this.onClick = this.onClick.bind(this);
    this.addEventListeners();
  }

  /**
   * Declare attribute constants
   */
  get attributes() {
    return {
      target: `${attributeBase}-target`,
      offset: `${attributeBase}-offset`,
      triggerClass: `${attributeBase}-trigger-class`
    };
  }

  /**
   * Subscribe to event listeners.
   */
  addEventListeners() {
    this.element.addEventListener('click', this.onClick.bind(this));
  }

  /**
   * Click event handler.
   */
  onClick() {
    if (this.triggerClass && this.element.classList.contains(this.triggerClass)) {
      return;
    }

    this.target.scrollIntoView({ behavior: 'smooth' });
  }

  /**
   * Get selector
   */
  static getSelector() {
    return `[${attributeBase}]`;
  }
}
